import { render, staticRenderFns } from "./DpaeTooltip.vue?vue&type=template&id=61323044&scoped=true&"
import script from "./DpaeTooltip.vue?vue&type=script&lang=js&"
export * from "./DpaeTooltip.vue?vue&type=script&lang=js&"
import style0 from "./DpaeTooltip.vue?vue&type=style&index=0&id=61323044&scoped=true&lang=css&"
import style1 from "./DpaeTooltip.vue?vue&type=style&index=1&id=61323044&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61323044",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61323044')) {
      api.createRecord('61323044', component.options)
    } else {
      api.reload('61323044', component.options)
    }
    module.hot.accept("./DpaeTooltip.vue?vue&type=template&id=61323044&scoped=true&", function () {
      api.rerender('61323044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DPAE/DpaeTooltip.vue"
export default component.exports